export const courseTitleFormat = (title) => {
    // Replace hyphens with spaces and capitalize each word
    return title
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

// Helper function to format answers with numbering
export const formatDescription = (answer) => {
  const applyFormatting = (text) => {
    // Apply bold formatting for **[text]**
    text = text.replace(/\*\*(.*?)\*\*/g, (_, match) => `<strong>${match}</strong>`);

    // Apply underline formatting for __[text]__
    text = text.replace(/__(.*?)__/g, (_, match) => `<u>${match}</u>`);

    // Apply italic formatting for *[text]*
    text = text.replace(/\*(.*?)\*/g, (_, match) => `<i>${match}</i>`);

    // Add breakpoints for \n
    text = text.replace(/\n/g, '<br />');

    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  };

  if (Array.isArray(answer)) {
    // If the answer is an array, format each item
    return (
      <div>
        {answer.map((item, index) => {
          if (/^\d+\.\s/.test(item)) {
            // Numbered list item
            return (
              <div key={index} style={{ paddingLeft: '20px' }}>
                <span>{item.match(/^\d+\.\s/)[0]}</span>
                <p style={{ display: 'inline' }}>{applyFormatting(item.replace(/^\d+\.\s/, ''))}</p>
              </div>
            );
          } else if (/^-\s/.test(item)) {
            // Bullet list item
            return (
              <div key={index} style={{ paddingLeft: '20px' }}>
                <li>{applyFormatting(item.replace(/^-\s/, ''))}</li>
              </div>
            );
          }
          // Regular text item
          return <p key={index} className="py-1">{applyFormatting(item)}</p>;
        })}
      </div>
    );
  }

  if (typeof answer === "string") {
    // If the answer is a string, treat it as a paragraph
    return <p className="py-1">{applyFormatting(answer)}</p>;
  }

  // If the answer is neither a string nor an array, return it as is
  return answer;
};

export const formatCharacterName = (char) => {
    // Format character name upper case on first letter of each word and replace underscores with spaces
    // E.g., "ice_climbers" -> "Ice Climbers"
    // Edge case for "Mr. Game & Watch and "Dr. Mario"
    if (char === "mr_game_and_watch") return "Mr. Game & Watch";
    if (char === "dr_mario") return "Dr. Mario";

    return char.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

// This is for contributions page but can be used elsewhere later as long as you stick to the format
export const CONTRIBUTION_CODES = {
  // Main characters (displayed as buttons)
  'fox': 'C-FOX',
  'falco': 'C-FALCO',
  'marth': 'C-MARTH',
  'sheik': 'C-SHEIK',
  'jigglypuff': 'C-PUFF',
  'peach': 'C-PEACH',
  'captain_falcon': 'C-FALCON',
  
  // Other characters (dropdown)
  'ice_climbers': 'C-ICIES',
  'samus': 'C-SAMUS',
  'yoshi': 'C-YOSHI',
  'pikachu': 'C-PIKA',
  'luigi': 'C-LUIGI',
  'dr_mario': 'C-DOC',
  'donkey_kong': 'C-DK',
  'ganondorf': 'C-GANON',
  'mario': 'C-MARIO',
  'link': 'C-LINK',
  'young_link': 'C-YL',
  'ness': 'C-NESS',
  'zelda': 'C-ZELDA',
  'mewtwo': 'C-MEWTWO',
  'roy': 'C-ROY',
  'mr_game_and_watch': 'C-GNW',
  'pichu': 'C-PCHU',
  'kirby': 'C-KIRBY',
  'bowser': 'C-BOWSER',
  
  // Special case
  'general_support': 'C-GENERAL'
};

export const CONTRIBUTION_CODES_REVERSE = Object.fromEntries(
  Object.entries(CONTRIBUTION_CODES).map(([key, value]) => [value, key])
);

export const subscriptionPlans = {
  '1MF': '1 Month Access Plan',
  '2MF': '2 Months Access Plan',
  '3MF': '3 Months Access Plan',
};

// Helper function to get the backend code
export const getContributionCode = (character) => {
  return CONTRIBUTION_CODES[character] || null;
};